import api from '@/services/api';

import { type Country, type CountryProductSummary, type CountryWithPlantDTO } from '../types';

const BASE_URL = 'countries';

export const getCountriesWithPlants = async () => {
  return await api.get<CountryWithPlantDTO[]>(`${BASE_URL}/plants`);
};

export const getCountriesWithPlantsByProduct = async (idProduct: number) => {
  return await api.get<CountryWithPlantDTO[]>(`${BASE_URL}/plants/by-product?idProduct=${idProduct}`);
};

export const getCountryProductSummary = async (idProduct: number) => {
  return await api.get<CountryProductSummary[]>(`${BASE_URL}/plants/summary?idProduct=${idProduct}`);
};

export const getCountries = async (withProducts = false) => {
  return await api.get<Country[]>(`${BASE_URL}?withProducts=${withProducts}`);
};

export const updateCountry = async (data: Country) => {
  await api.put(`${BASE_URL}/${data.idCountry}`, data);
  return data;
};

export const createCountry = async (data: Country) => {
  await api.post(BASE_URL, data);
  return data;
};

export const deleteCountry = async (id: number) => {
  await api.delete(`${BASE_URL}/${id}`);
};
